// src/features/tasks/components/TasksPageHeader.jsx
import React, { useState } from 'react';
import {
  Button,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  Add as AddIcon,
  Refresh as RefreshIcon,
  ArrowDropDown as ArrowDropDownIcon,
  FileCopy as FileCopyIcon,
  NoteAdd as NoteAddIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import PageHeader from '../../../../components/common/PageHeader';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

export default function TasksPageHeader({
  onRefresh,
  onCreateClick,
  canCreate,
  loading,
}) {
  const { t } = useTranslation(['tasks']);
  const navigate = useNavigate();
  const [createMenuAnchor, setCreateMenuAnchor] = useState(null);

  const handleOpenCreateMenu = (event) => {
    setCreateMenuAnchor(event.currentTarget);
  };

  const handleCloseCreateMenu = () => {
    setCreateMenuAnchor(null);
  };

  const handleCreateFromScratch = () => {
    handleCloseCreateMenu();
    onCreateClick();
  };

  const handleCreateFromTemplate = () => {
    handleCloseCreateMenu();
    navigate('/tasks/catalog');
  };

  return (
    <PageHeader
      icon={TaskAltIcon}
      title={t('tasks:list_page.title')}
      subtitle={t('tasks:subtitle')}
      actions={<>
        <Tooltip title={t('tasks:list_page.refresh')}>
          <IconButton onClick={onRefresh} disabled={loading}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
        
        {canCreate && (
          <>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              endIcon={<ArrowDropDownIcon />}
              onClick={handleOpenCreateMenu}
            >
              {t('tasks:list_page.create_task')}
            </Button>
            
            <Menu
              anchorEl={createMenuAnchor}
              open={Boolean(createMenuAnchor)}
              onClose={handleCloseCreateMenu}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem onClick={handleCreateFromTemplate}>
                <ListItemIcon>
                  <FileCopyIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>
                  {t('tasks:list_page.create_from_template')}
                </ListItemText>
              </MenuItem>

              <MenuItem onClick={handleCreateFromScratch}>
                <ListItemIcon>
                  <NoteAddIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>
                  {t('tasks:list_page.create_from_scratch')}
                </ListItemText>
              </MenuItem>
            </Menu>
          </>
        )}
      </>}
    />
  );
}